<template>
    <b-container>
        <b-row>
            <b-col>
                <label>Columns: </label>
                <b-form-spinbutton
                        v-model="imageGrid.size"
                        min="1"
                        max="4"
                        step="1"
                ></b-form-spinbutton>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <image-input @input="selectImage" :inline="true" label="Add Image" name="img-select"></image-input>
                <draggable class="row" v-model="imageGrid.imageList">
                    <b-col :key="index" v-for="(element, index) in imageGrid.imageList" :md="12 / imageGrid.size">
                        <img class="thumbnail" width="100%"
                             :src="fileResourceUrl(element)"/>
                        <b-button variant="link" @click="removeImage(element)">
                            <i class="fal fa-trash-alt"></i>
                        </b-button>
                    </b-col>
                </draggable>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>

    import ImageInput from "./ImageInput";
    import draggable from 'vuedraggable';

    export default {
        name: 'image-grid',
        props: ['placeholder', 'label', 'name', 'value'],
        data() {
            return {
                imageGrid : this.value ? this.value : {
                    size: 4,
                    imageList: []
                },
            }
        },
        components: {
            'image-input': ImageInput,
            'draggable': draggable
        },
        methods: {
            selectImage(image) {
                this.imageGrid.imageList.push(image);
            },
            removeImage(image) {
                let index = this.imageGrid.imageList.indexOf(image);
                this.imageGrid.imageList.splice(index, 1);
            },
        },
        watch: {
            imageGrid: {
                handler(val) {
                    this.$emit('input', val);
                },
                deep: true
            }
        },
    };

</script>
